import $ from 'jquery'

const debounce = (fn, wait) => {
  let timeout
  return function (...args) {
    const ctx = this
    clearTimeout(timeout)
    timeout = setTimeout(() => fn.apply(ctx, args), wait)
  }
}

export function initOrganizationAutocomplete () {
  let $parentContainer = null
  let $organizationNameField = null
  let $requestedOrganizationsContainer = null
  let $spinner = null
  let $organizationResultsContainer = null
  let $userState = null

  let searchTerm = null
  let page = 1
  let reviewId = null
  let from = null
  let observer = null

  const setup = () => {
    $parentContainer = $('.organization-container')
    $organizationNameField = $parentContainer.find('.organization-name')

    if ($organizationNameField.data().review) {
      reviewId = $organizationNameField.data().review.id
    }

    from = $organizationNameField.data().from

    if (observer && $parentContainer.find('.trigger-next-page')[0]) {
      observer.unobserve($parentContainer.find('.trigger-next-page')[0])
    }

    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting === true) {
          search(entries[0].target)
        }
      },
      { threshold: [0] }
    )
  }

  const search = (target) => {
    $parentContainer = $(target).parents('.organization-container')
    $organizationNameField = $parentContainer.find('.organization-name')
    $requestedOrganizationsContainer = $parentContainer.find('#request-organizations')
    $spinner = $requestedOrganizationsContainer.find('.loading-spinner')
    $organizationResultsContainer = $requestedOrganizationsContainer.find('.organization-results')
    $userState = $parentContainer.parents('#new_user').find('#user_state')

    $spinner.show()

    if (page === 1) {
      $organizationResultsContainer.empty()
      $organizationNameField.addClass('searching')
      $requestedOrganizationsContainer.slideDown()
    }

    $.ajax({
      url: '/organizations/autocomplete',
      data: {
        search: searchTerm,
        page,
        from,
        review_id: reviewId,
        state: $userState.val(),
        agency: true
      }
    }).done((response) => {
      $spinner.hide()

      if (!response.organizations || response.organizations.length === 0) {
        return false
      }

      if (page === 1) {
        $organizationResultsContainer.append(
          '<div><b>Matching Procurated Member Agencies</b></div>'
        )
      }

      $organizationResultsContainer
        .find('.search-row')
        .removeClass('trigger-next-page')

      response.organizations.forEach((organization, index) => {
        const div = $('<div/>', {
          id: `organization-${organization.id}`,
          class:
            'search-row ' +
            (index === response.organizations.length - 10
              ? 'trigger-next-page'
              : ''),
          text: organization.name,
          'data-name': organization.name,
          'data-id': organization.id
        })

        $organizationResultsContainer.append(div)
      })

      const $trigger = $parentContainer.find('.trigger-next-page')

      if (observer && $trigger[0]) {
        observer.unobserve($trigger[0])
      }

      if (response.next_page && observer && $trigger[0]) {
        page = response.next_page
        observer.observe($trigger[0])
      }
    })
  }

  const updateUserOrganization = (reviewId, organizationName) => {
    $.ajax({
      url: `/reviews/${reviewId}`,
      method: 'PATCH',
      data: {
        review: {
          user_organization_name_flex: organizationName
        }
      }
    })
  }

  $('body')
    .off('change.organizationAutocomplete', '.user-state')
    .on('change.organizationAutocomplete', '.user-state', () => {
      $('.organization-name').val('')
      if ($requestedOrganizationsContainer) {
        $requestedOrganizationsContainer.hide()
      }
    })

  $('body')
    .off('focus.organizationAutocomplete', '.organization-name')
    .on('focus.organizationAutocomplete', '.organization-name', (event) => {
      setup()
    })

  $('body')
    .off('keyup.organizationAutocomplete', '.organization-name')
    .on(
      'keyup.organizationAutocomplete',
      '.organization-name',
      debounce((event) => {
        searchTerm = event.target.value

        if (!searchTerm || searchTerm.length < 2) return false

        page = 1
        search(event.target)
      }, 500)
    )

  $('body')
    .off('click.organizationAutocomplete', '.organization-results .search-row')
    .on(
      'click.organizationAutocomplete',
      '.organization-results .search-row',
      (event) => {
        const name = $(event.target).data('name')
        $organizationNameField.val(name)

        $organizationNameField.removeClass('searching')
        $requestedOrganizationsContainer.hide()

        if (reviewId) {
          updateUserOrganization(reviewId, name)
        }
      }
    )
}
